﻿import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            profilePictureUrl: String,
            editPictureModalId: String
        };
    }

    static get targets() {
        return ["picture"];
    }

    closeEditPictureModalAndRefreshPicture() {
        //TODO: should import Modal rather than relying on global bootstrap but having both causes 2 backdrops to render
        bootstrap.Modal.getInstance(document.getElementById(this.editPictureModalIdValue)).hide();
        this.pictureTarget.src = `${this.profilePictureUrlValue}?width=${this.pictureTarget.getAttribute("width")}&height=${this.pictureTarget.getAttribute("height")}&${new Date().getTime()}`;
    }
}
